import store from "../store/index"
import { decrypt, asyncTask, getCookie, handleWebjsonBeforeInit } from "utils"
import { reverseBuildModel, reverseBuildModelForBigScreen } from "utils/reverseBuildModel.js"
import { initBigScreenData } from "./initBigScreenPreview"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import instance from "../interceptor"
import { event } from "utils/event"
import { v1 } from "uuid"
import api from "../api/index"
// 初始化路由数据
/**
 * isRouterChange为true表示是路由切换，false表示是页面刷新
 * @param {*} isRouterChange
 * @returns
 */
export async function initUrlQueryDataBigScreen(isRouterChange) {
  //格式化url的query
  const urlQuery = GetRequest()
  let { w, p, sign, pageId, websiteId, e, t, d, a, hp, noswiper } = urlQuery
  w = w || websiteId
  p = p || pageId
  const param = {}
  await initGetCookie()
  let myCookie = store.state.states.myCookie
  let wfwfid = myCookie.website_fid
  param.wfwfid = wfwfid ? wfwfid : "65692"
  param.engineInstanceId = e
  param.typeId = t
  param.dataId = d
  param.appId = a
  param.homePageId = hp
  param.pageType = isRouterChange
  param.noswiper = noswiper
  // 大屏预览页做心跳接口监测
  if ((window.previewUrl || location.href).indexOf("bigScreenPreview") !== -1) {
    judgeDeviceNum(w)
  }
  // 先判断当前网站在线设备数量，限制数据，杜绝频繁调用大屏接口，后端压力太大
  if (w && p) {
    Object.keys(urlQuery).forEach(item => {
      if (item === "p") {
        param.pageId = urlQuery[item]
      } else if (item === "w") {
        param.websiteId = urlQuery[item]
      }
    })
    // 根据localStorage中的参数判断当前页面类型
    window.localStorage.removeItem("detailData")
    store.commit("states/updateDataPageIds", param)
  } else {
    param.sign = "92e29c58b56735a1492183d1fb7281a5"
    store.commit("states/updateDataPageIds", param)
  }
  //初始化跨页面传参
  if (localStorage.getItem("pageQuery")) {
    const pageQuery = localStorage.getItem("pageQuery") || ""
    localStorage.removeItem("pageQuery")
    const uuid = v1()
    window.pageQueryUid = uuid
    sessionStorage.setItem(uuid, pageQuery)
  }
  if ((window.previewUrl || location.href).indexOf("bigScreenPreview") !== -1) {
    await initBigScreenData(param)
  } else {
    await initStageData(param)
  }

  /*关掉loading 动画*/
  setTimeout(() => {
    const pageLoadingBox = document.getElementById("pageLoadingBox")
    pageLoadingBox && (pageLoadingBox.style.display = "none")
    window.pagView?.stop()
    window.pagView?.destroy()
  }, 100)
}
// 判断当前网站在线设备数是否大于限制的数量
function judgeDeviceNum(w) {
  let uid = sessionStorage.getItem("myUUid")
  if (!uid) {
    uid = window.bsId
    sessionStorage.setItem("myUUid", uid)
  }
  w = window.previewUrl ? window.webPubId : w
  instance
    .get(`v2/beat/${w}`)
    .then(res => {
      console.log("res",res.data)
      if (res.data && !res.data.data) {
        // 跳转到访问受限页面
        sessionStorage.setItem("isDeviceError", true)
        sessionStorage.setItem("historyHref", window.location.href)
        const preUrl = process.env.VUE_APP_IS_GRAY ? "/page-v2" : "/page-v21"
        window.location.href =window.location.origin+preUrl+'/deviceError'
        return
      } else {
        setTimeout(() => {
          judgeDeviceNum(w)
        }, 60000)
      }
    })
    .catch(() => {})
}
export async function initStageData(param) {
  const { pageId } = param
  console.log("param", param)
  if (!pageId) {
    console.log("缺少pageId")
    return
  }
  await initPcStageData(pageId, param)
}
/**
 * 初始化pc端数据
 */
export async function initPcStageData(pageId, param) {
  const res = await getPageData(pageId, 0)
  //判断是否有模板
  if (res.data.data) {
    let stage = JSON.parse(res.data.data)
    if (!stage.hasOwnProperty("page")) return // 如果没有page属性，说明是纯移动端模版，pc端不需要初始化
    parseInt(stage.version)
    if (stage.type === "bigScreen") {
      stage = decrypt(JSON.stringify(stage), data_dictionary_map)
      if (stage.hasOwnProperty("version") && stage.version === 0) {
        return
      }
      reverseBuildModelForBigScreen(stage)
      handleWebjsonBeforeInit(stage)
      store.dispatch("bigScreen/initWebJson", stage)
    } else if (stage.type === "normal" || stage.type === "stage" || stage.page?.isPhoneFullScreen) {
      stage = decrypt(JSON.stringify(stage), data_dictionary_map)
      if (stage.hasOwnProperty("version") && stage.version === 0) {
        return
      }
      reverseBuildModel(stage)
      // 针对旧数据没得containerId的做兼容
      stage.page.children.forEach((child, index) => {
        if (!child.hasOwnProperty("container_id")) {
          child.container_id = index
        }
      })
      handleWebjsonBeforeInit(stage)
      store.dispatch("stage/initWebJson", stage)
    } else if (stage.type === "listPage" || stage.type === "detailPage") {
      // 当前页面为子页面
      stage = await handleSubPageData(stage, param, 0)
      handleWebjsonBeforeInit(stage)
      store.dispatch("stage/initWebJson", stage)
    }
    event.init(stage.event ? stage.event : {}, "stage")
    setTimeout(() => {
      if (document.getElementsByName("editPage").length > 0) {
        document.getElementsByClassName("loading-box")[0].style.display = "none"
      }
    }, 500)
  } else {
    //没模板 用默认数据
    console.log("useLocalTemplate")
    localStorage.setItem("useLocalTemplate", "true")
  }
}

// 获取页面cookie
async function initGetCookie() {
  let myCookie = await getCookie("UID,current_page_id,website_id,website_fid,fid,webIdEnc,SUID")
  store.commit("states/updateMyCookie", myCookie)
}
export function GetRequest() {
  var url = window.previewUrl || location.href //获取url中"?"符后的字串
  var theRequest = new Object()
  if (url.indexOf("?") != -1) {
    var str = url.split("?")[1]
    var strs = str.split("&")
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
    }
  }
  return theRequest
}

/**
 * 获取page数据
 * @param homePageId
 * @param type
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function getPageData(homePageId, type) {
  return instance.get(`v2/webjson/edit/${homePageId}/content?a=${type}`)
}

/**
 * 非外接数据源请求数据集合接口all-request
 * @param pageId
 * @param websiteId
 * @param isMobile
 */
export function getNoneExternalDataSource(pageId, websiteId, isMobile, version) {
  asyncTask.initAllReq(instance.get(`v2/${pageId}/all-request?w=${websiteId}&m=${isMobile}&v=${version}`))
}
/**
 * 判断详情页列表页访问权限
 * @param publicId
 * @param dataId
 */
export async function getDataLimit(publicId, dataId) {
  return api.getDetailPagePermission({
    publicId: publicId,
    dataId: dataId
  })
}
